<template>
    <div class="LightingSystem" >
        <Title firstName="照明系统状态" lastName="LIGHTING SYSTEM STATUS"/>
        <div class="echarts">
            <div class="floor">
               <div class="item">
                   <div class="title">办公区照明</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="status">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
               <div class="item">
                   <div class="title">休息区照明</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="status">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
               <div class="item">
                   <div class="title">走廊照明</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="status">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
           </div>
            <div class="state"  >
                <div class="item">
                    <div class="title">照明月用电</div>
                    <div class="num">--<span>kWh</span></div>
                </div>
                <div class="item">
                    <div class="title">用电功率</div>
                    <div class="num">--<span>kVA</span></div>
                </div>
                <div class="item">
                    <div class="title">室外照度</div>
                    <div class="num">--<span>LUX</span></div>
                </div>
                <div class="item">
                    <div class="title">设备启停</div>
                    <div class="num">--<span>/--</span></div>
                </div>
                
            </div>
            <div class="btn btn1" >
                <div class="report">自动模式</div>
                <div class="report">手动模式</div>
            </div>
            
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
export default {
    inject:['buildId', 'floorId'],
    data(){
        return {
            
        }
    },
    components:{
        Title,Graph,charts
    },
    computed:{
		getBuildId(){
			return this.buildId()
		},
		getFloorId(){
			return this.floorId()
		}
	},
    mounted(){
        
    },
    methods:{
       
    },
}
</script>

<style lang="less" scoped>
    .LightingSystem{
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 40.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            .btn{
                display: flex;
                color: rgba(230, 243, 253, 0.7);
                justify-content: space-evenly;
                align-items: center;
                align-content: space-around;
                height: 9vh;
                flex-wrap: wrap;
                padding: 0 1vw;

                .report{
                    background: url("../../../../assets/img/btn3.png") no-repeat center;
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    width: 120rem;
                    cursor: pointer;
                }
            }
            .btn1{
                justify-content: space-evenly;
            }
            
            .state{
                height: 8vh;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                align-content: space-evenly;
                .item{
                    text-align: center;

                    .title{
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        color: rgba(230,243,253,0.7);
                    }
                    .num{
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        color: #00DEFF;
                        &>span{
                            font-size: 14rem;
                        }
                    }
                }
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }

            .floor{
                padding:0 30rem;
                display: flex;
                align-items: center; 
                justify-content: space-between;
                .item{
                    overflow: hidden;
                    color: rgba(230, 243, 253, 0.7);
                    font-size: 16rem;
                    margin:3.5vh 0;
                    text-align: center;
                    .title{
                        margin-bottom: 5rem;
                    }
                    .progress{
                        background: url('../../../../assets/img/bottom.png');
                        width:100rem;
                        height: 100rem;
                        background-size: 100% 100%;
                        margin: 15rem 0;
                        display: flex;
                        flex-flow: row wrap;
                        align-items: center;
                        padding: 17rem 0;
                        font-size: 16rem;
                        .num{
                            color: #00DEFF;
                            font-size: 22rem;
                            width: 100%;
                            font-family: zcoolqingkehuangyouti;
                            span{
                                font-size: 16rem;
                                font-family: zcoolqingkehuangyouti;
                            }
                        }
                        .status{
                            text-align: center;
                            width: 100%;
                        }
                    }
                    .error{

                    }
                }
            }
        }
    }

</style>